import React, { Component } from 'react';
import { Link } from "react-router-dom";

class Terms_Condition extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <div>
               <div class="page_title">
                    <h1>Terms & Condition</h1>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li class="breadcrumb-item active" aria-current="page">Terms & Condition</li>
                        </ol>
                    </nav>

                </div> 

                <div class=" container-fluid  mt-10 mb-10" >
                    <div class="container ">
                        <h2 class="section_title text-center">Terms & Condition</h2>
                        <p class="text-center">Terms & Condition Coming Soon</p>
                        
                    </div>
                </div>
            </div>
        );
    }
}

export default Terms_Condition;